import * as z from 'zod';

import { billingSystemQuerySchema } from './billing-system-query-schema';

export const billingSystemUpdateSchema = billingSystemQuerySchema
  .pick({ id: true, name: true })
  .extend({ status: z.string() });
export type BillingSystemUpdateSchema = z.infer<typeof billingSystemUpdateSchema>;

export const billingSystemCreateSchema = billingSystemUpdateSchema.omit({ id: true });
export type BillingSystemCreateSchema = z.infer<typeof billingSystemCreateSchema>;
